// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__.O(undefined, ["webpack_sharing_provide_default_lingui_core-webpack_sharing_provide_default_lingui_react-webp-f7b8f8"], function() { return __webpack_require__("./src/external.js"); })
var __webpack_exports__ = __webpack_require__.O(undefined, ["webpack_sharing_provide_default_lingui_core-webpack_sharing_provide_default_lingui_react-webp-f7b8f8"], function() { return __webpack_require__("webpack/container/entry/widgets"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
